/* tslint:disable */
import {
  Page
} from '../index';

declare var Object: any;
export interface ArticleInterface {
  "title": string;
  "content": string;
  "created": Date;
  "updated": Date;
  "id"?: any;
  page?: Page;
}

export class Article implements ArticleInterface {
  "title": string;
  "content": string;
  "created": Date;
  "updated": Date;
  "id": any;
  page: Page;
  constructor(data?: ArticleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Article`.
   */
  public static getModelName() {
    return "Article";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Article for dynamic purposes.
  **/
  public static factory(data: ArticleInterface): Article{
    return new Article(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Article',
      plural: 'articles',
      properties: {
        "title": {
          name: 'title',
          type: 'string'
        },
        "content": {
          name: 'content',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
        "updated": {
          name: 'updated',
          type: 'Date',
          default: new Date(0)
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        page: {
          name: 'page',
          type: 'Page',
          model: 'Page'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Article.ts